import * as fromDatatype from '../datatype-library/index';

export interface bl_msg_message_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  msg_header: fromDatatype.TextDatatypeInterface;
  msg_subject: fromDatatype.TextDatatypeInterface;
  msg_summary: fromDatatype.TextDatatypeInterface;
  msg_body_txt: fromDatatype.TextDatatypeInterface;
  msg_body_html: fromDatatype.TextDatatypeInterface;
  msg_type: fromDatatype.VarcharDatatypeInterface;
  msg_body_json: fromDatatype.JsonDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class bl_msg_message_hdr_RowClass implements bl_msg_message_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  msg_header: fromDatatype.TextDatatypeInterface;
  msg_subject: fromDatatype.TextDatatypeInterface;
  msg_summary: fromDatatype.TextDatatypeInterface;
  msg_body_txt: fromDatatype.TextDatatypeInterface;
  msg_body_html: fromDatatype.TextDatatypeInterface;
  msg_type: fromDatatype.VarcharDatatypeInterface;
  msg_body_json: fromDatatype.JsonDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}

